import React, { useEffect, useState } from 'react'
import { Container, Button, Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { editUser, getUser, removeUser } from '../../actions/usersActions'

export default function Config() {
    const { t } = useTranslation()
	const {client,logout} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {user, resultuser, deletionResult} = useSelector(state=>state.users)

    const [isUpdating, setIslogging] = useState(false)
    const [passwordverify, setPasswordverify] = useState("")

    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const [showPasswordTwo, setShowPasswordTwo] = useState(false)

    const [formState, setFormState] = useState({})

    useEffect(() => {
        if(client){
            dispatch(getUser(client?.id))
        }
    },[dispatch, t, client])

    useEffect(() => {
        if(user){
            setFormState({
                firstname: user.firstname,
                phone: user.phone,
                birthdate: user.birthdate?.substring(0, 10),
                email: user.email,
                password: ''
            })
        }
    // eslint-disable-next-line
    }, [user])

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne)
    }

    const handlePasswordVisibilityTwo = () => {
        setShowPasswordTwo(!showPasswordTwo)
    }

    const checkValidation = (isPassVer, e) => {
        const confirmPass = e.target.value

        if(isPassVer){
            setPasswordverify(confirmPass)
        }else{
            setFormState({
                ...formState,
                'password': confirmPass
            })
        }
    }

    const handleEdit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        if(formState.password === passwordverify || formState.password === ''){
            if((formState.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,15}$/g) && formState.password === passwordverify) || formState.password === ''){
                dispatch(editUser(formState, user.id))
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'warning',
                    text: t('users.passwordsnotvalid')
                })
            }
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.passwordsnotmatch')
            })
        }
        setIslogging(false)
    }

    const handleDeleteAccountBtn = () => {
        Swal.fire({
            showCancelButton: true,
            icon: 'warning',
            text: t('users.deleteAccountConfirmationQuestion'),
            confirmButtonText: t('users.deleteAccountBtn'),
            confirmButtonColor: 'var(--rojo)',
            cancelButtonText: t('users.cancelDeleteAccountBtn')
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(removeUser(user?.id))
            }
        })
    }

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.updated')
                    }).then((resultuser) => {
                        if (resultuser.isConfirmed) {
                            navigate('/client/dashboard')
                        }
                    })
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    useEffect(() => {
        if (deletionResult) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'success',
                text: t('users.userDeleted')
            })
            dispatch({type: "USER_REMOVE_RESET"})
            logout()
        }
    // eslint-disable-next-line
    }, [deletionResult, dispatch])

    return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link to={`/${client?.rol?.toLowerCase()}/dashboard`}>
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1>{t('users.updatedata')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="my-3">
                <Col className="justify-content-center">
                    <Form className="px-4 formulario" onSubmit={handleEdit}>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.firstname')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='firstname' 
                                value={formState.firstname ||  ''}
                                placeholder={t('users.setfirstname')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.phone')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='phone' 
                                value={formState.phone ||  ''}
                                placeholder={t('users.setphone')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.birthdate')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='date'
                                name='birthdate' 
                                value={formState.birthdate ||  ''}
                                placeholder={t('users.birthdate')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.email')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='email'
                                name='email' 
                                value={formState.email || ''}
                                placeholder={t('users.setemail')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center mt-3">
                            <h2 className="sd-label text-start">{t('users.password')}</h2>
                        </Row>
                        <Row className="text-center mb-3 row-eye">
                            <Form.Control
                                className="sd-input"
                                type={showPasswordOne ? 'text' : 'password'}
                                name='password' 
                                value={formState.password ||  ''}
                                placeholder={t('users.setpassword')}
                                onChange={(e) => checkValidation(false, e)}
                            />
                            <img className="sd-imageneye" src={showPasswordOne ? "../images/eyeclose.svg" : "../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne}></img>
                        </Row>
                        <Row className="my-3">
                            <p>
                                <span className='fs-12 fw-400 ps-1'>{t('users.passwordneed1')}</span><br/>
                                <span className='password-list'>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed2')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed3')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed4')}</span>
                                </span>
                            </p>
                        </Row>
                        <Row className="text-center mt-3">
                            <h2 className="sd-label text-start">{t('users.passwordconfirm')}</h2>
                        </Row>
                        <Row className="text-center mb-3 row-eye">
                            <Form.Control
                                className="sd-input"
                                type={showPasswordTwo ? 'text' : 'password'}
                                name='passwordcheck'
                                placeholder={t('users.setpasswordconfirm')}
                                onChange={(e) => checkValidation(true, e)}
                            />
                            <img className="sd-imageneye" src={showPasswordTwo ? "../images/eyeclose.svg" : "../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityTwo}></img>
                        </Row>
                        <Row className="text-center my-3">
                            <Col>
                                <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                                {isUpdating
                                    ?
                                        <>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </>
                                    :
                                        <>{t('users.update')}</>
                                }
                                </Button>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col className='d-grid'>
                                <Button variant='warning' type='button' onClick={() => handleDeleteAccountBtn()}>
                                    {t('users.deleteAccount')}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}